import { CommentFormItem } from '../CommentFormItem'
import { DispositionSelector } from '../DispositionSelector'
import { REReviewerActionsProps } from './types'
import { useRequireCommentByDisposition } from '../../hooks/useRequireCommentByDisposition'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useWatch } from 'antd/lib/form/Form'

export const REReviewerActions: React.VFC<REReviewerActionsProps> = ({
  form,
}) => {
  const { required } = useRequireCommentByDisposition(form)
  const action = useWatch('action', form)
  return (
    <>
      <CIMSFormItem
        initialValue="reReview"
        name="action"
        label="Action"
        requiredMessage="Please select an action"
      >
        <CIMSSelect
          simple
          options={[
            {
              label: 'Submit Disposition',
              value: 'reReview',
              commentAction: 'disposition',
            },
            {
              label: 'Request Revisions',
              value: 'requestRevisions',
              commentAction: 'review',
            },
          ]}
        />
      </CIMSFormItem>
      {action === 'reReview' && <DispositionSelector />}
      <CommentFormItem
        required={required ? { action: 'disposition' } : false}
      />
    </>
  )
}
